import { createI18n } from 'vue-i18n'
import ar from '@/locales/ar.json'
import de from '@/locales/de.json'
import en from '@/locales/en.json'
import es from '@/locales/es.json'
import fr from '@/locales/fr.json'
import hi from '@/locales/hi.json'
import id from '@/locales/id.json'
import ja from '@/locales/ja.json'
import ko from '@/locales/ko.json'
import pt from '@/locales/pt.json'
import ru from '@/locales/ru.json'
import tr from '@/locales/tr.json'
import vi from '@/locales/vi.json'
import zh from '@/locales/zh.json'

export type MessageSchema = typeof ru

export type SupportedLocale =
  | 'ru'
  | 'en'
  | 'fr'
  | 'es'
  | 'de'
  | 'pt'
  | 'zh'
  | 'ja'
  | 'ko'
  | 'ar'
  | 'tr'
  | 'vi'
  | 'hi'
  | 'id'

const SUPPORTED_LOCALES: SupportedLocale[] = [
  'ru',
  'en',
  'fr',
  'es',
  'de',
  'pt',
  'zh',
  'ja',
  'ko',
  'ar',
  'tr',
  'vi',
  'hi',
  'id',
]

const STORAGE_KEY = 'tlh-locale'

/**
 * Получить сохранённую локаль из localStorage
 */
function getSavedLocale(): SupportedLocale {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved && SUPPORTED_LOCALES.includes(saved as SupportedLocale)) {
      return saved as SupportedLocale
    }
  } catch {
    // localStorage недоступен (SSR или incognito)
  }

  // Попробовать определить по языку браузера
  const browserLang = navigator.language.split('-')[0]
  if (SUPPORTED_LOCALES.includes(browserLang as SupportedLocale)) {
    return browserLang as SupportedLocale
  }

  return 'ru'
}

/**
 * Сохранить локаль в localStorage
 */
export function saveLocale(locale: SupportedLocale): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    // localStorage недоступен
  }
}

export default createI18n<[MessageSchema], SupportedLocale>({
  legacy: false,
  locale: getSavedLocale(),
  fallbackLocale: 'en',
  messages: {
    ru,
    en,
    fr,
    es,
    de,
    pt,
    zh,
    ja,
    ko,
    ar,
    tr,
    vi,
    hi,
    id,
  },
})
